import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-customer-navigation',
    templateUrl: './customer-navigation.component.html',
    styleUrls: [],
    standalone: false
})
export class CustomerNavigationComponent implements OnInit {

  @Input()
  id: string;

  constructor() { }

  ngOnInit() {
  }

}
